module.exports = __webpack_public_path__ + "384417c25e84830cbc7a5a27697ee196.pdf";